import colors, { TypeColorNames } from "../../../theme/colors";

export default function ThreeBarsIcon({ size, color }: { size?: string, color?: TypeColorNames }) {
  return (
    <svg
      style={{
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      width={size || "12"}
      height={size || "12"}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.7002 3.6H14.7002"
        stroke={color ? colors[color] : colors.placeholder}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M2.8501 14.55H13.2001"
        stroke={color ? colors[color] : colors.placeholder}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M2.8501 9.15H11.8501"
        stroke={color ? colors[color] : colors.placeholder}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
